module.exports = __webpack_public_path__ + "static/img/case_detail_07_2.1874a61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_07_2.png
// module id = akos
// module chunks = 34